var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2010_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1897 29.1888L16.4949 13.2515L22.5176 7.14514L28.204 26.133L25.1897 29.1888ZM17.6578 13.4149L25.4096 27.6234L27.1409 25.8684L22.0714 8.93975L17.6578 13.4149Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4778 12.2191L1.00684 4.66336L4.0127 1.61438L19.9003 6.50461L19.6228 7.40555L4.28223 2.68313L2.54504 4.44563L14.939 11.3972L14.4778 12.2191Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 30L7.09809 23.3067L6.79598 23.0004L0.206055 19.3048L2.88754 16.5858L8.16449 18.21L24.9052 1.23633C25.6001 0.531797 26.8803 0.000234375 27.8829 0H27.8836C28.4726 0 28.9594 0.178359 29.2922 0.515391C30.3357 1.57289 29.58 3.93141 28.5807 4.94484L23.2784 10.3214L22.6074 9.65977L27.9096 4.2832C28.6723 3.51 29.1779 1.74141 28.6214 1.1775C28.43 0.983672 28.1147 0.942656 27.8839 0.942656H27.8834C27.0404 0.942891 26.0297 1.43883 25.5764 1.89844L8.43426 19.2792L3.15707 17.655L1.74449 19.087L7.37324 22.2441L7.86168 22.7393L10.9695 28.4348L12.3746 27.0098L10.7726 21.6584L16.3407 16.0132L17.0117 16.6751L11.836 21.923L13.4377 27.274L10.7499 30Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4741 20.2588L9.80322 19.5969L5.21594 24.2469L5.88685 24.9088L10.4741 20.2588Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30831 10.7085L7.63721 10.0469L3.61623 14.1257L4.28733 14.7873L8.30831 10.7085Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44142 9.24524L4.77051 8.58337L2.76434 10.617L3.43525 11.2788L5.44142 9.24524Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8902 22.4514L19.2195 21.7898L15.1975 25.8673L15.8683 26.5289L19.8902 22.4514Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3348 25.3589L20.6641 24.6973L18.6587 26.7304L19.3294 27.392L21.3348 25.3589Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2010_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlights);
export default __webpack_public_path__ + "static/media/flights.e3b440a0709736ad1ab1af24b1ed1fae.svg";
export { ForwardRef as ReactComponent };